import { Dispatch, SetStateAction, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import CardContent from '@material-ui/core/CardContent';
import BlueFullWidthButton from 'components/BlueFullWidthButton/BlueFullWidthButton';
import styled from 'styled-components/macro';

import fourLeaf from '../../assets/img10.png';
import { StyledCard, StyledTitle } from './styled';

const StyledImg = styled.img`
    & {
        filter: brightness(100%);
        transition: filter 0.4s ease;
    }

    &:hover {
        filter: brightness(85%);
    }

    &:active {
        filter: brightness(75%);
        transition: filter 0.01s ease;
    }
`;

interface Props {
    setIsSelfAssessmentDialogOpen: Dispatch<SetStateAction<boolean>>;
}

const Card9 = ({ setIsSelfAssessmentDialogOpen }: Props) => {
    const { t } = useTranslation();

    const onClick = useCallback(() => {
        setIsSelfAssessmentDialogOpen(true);
    }, [setIsSelfAssessmentDialogOpen]);

    return (
        <>
            <StyledCard variant='outlined'>
                <CardContent style={{ height: '100%' }}>
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <StyledTitle style={{ fontSize: '1.65rem', fontWeight: 500, marginBottom: '4px' }}>
                            {t('pages.dashboard.cards.self_assessment.title')}
                        </StyledTitle>

                        <StyledTitle style={{ fontSize: '1rem' }}>
                            {t('pages.dashboard.cards.self_assessment.description')}
                        </StyledTitle>

                        <StyledImg src={fourLeaf} style={{ maxWidth: '100%', maxHeight: '120px', display: 'block', margin: '24px auto 12px', cursor: 'pointer' }} onClick={onClick} />

                        <div style={{ flexGrow: 1 }} />

                        <BlueFullWidthButton variant='contained' color='primary' style={{ width: 'calc(100% + 44px)', margin: '24px -22px -18px' }} onClick={onClick}>
                            {t('pages.dashboard.cards.self_assessment.button')}
                        </BlueFullWidthButton>
                    </div>
                </CardContent>
            </StyledCard>


        </>
    );
};

export default Card9;
